import { Form, Formik } from 'formik';
import { observer } from 'mobx-react-lite';
import { Button, Grid } from 'semantic-ui-react';
import MyTextInput from '../../app/common/form/MyTextInput';
import { useStore } from '../../app/stores/store';
import * as Yup from 'yup';
import { Link, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { GetSingleUserById } from '../../app/models/user';
import { v4 as uuid } from 'uuid';
import MySelectInput from '../../app/common/form/MySelectInput';
import { toast } from 'react-toastify';
import UnauthorizedMessage from '../UnauthorizedMessage';
import LoadingComponent from '../../app/layout/LoadingComponent';
import { userLanguage } from '../../app/common/userLanguageSchema/userLanguage';

export default observer(function RegisterForm() {
  const {
    userStore,
    RolesAndPermissionsStore,
    commonStore,
    departmentStore,
    dashboardStore,
    modalStore,
  } = useStore();
  const history = useNavigate();
  const { rolesByName, rolesRegistry, loadRoles } = RolesAndPermissionsStore;
  const { register, user, loadAllUsers, loadAllUserss } = userStore;
  const { getDepartmentsByCustomer, createUserDepartmentList } =
    departmentStore;
  const header = {
    height: '100vh',
    overflow: 'auto',
  };
  const phoneRegExp = /^(\+|\d)[0-9]{9,16}$/;
  const initialState: any = {
    id: '',
    displayName: '',
    password: '',
    newpassword: '',
    email: '',
    username: '',
    fullName: '',
    customerName: user?.customerName,
    departmentName: '',
    addressLine1: '',
    addressLine2: '',
    country: '',
    state: '',
    city: '',
    postalCode: '',
    phoneNumber: '',
    alternatePhoneNumber: '',
    remarks: '',
    role: '',
    workPosition: '',
    superior: '',
    website: '',
    workDepartment: '',
    workApplicationsKnown: '',
    languagesKnown: '',
    photos: [],
    image: '',
    roleId: '',
    isAdmin: true,
    roleName: '',
  };
  const [departmentdata, setdepartmentdata] =
    useState<GetSingleUserById>(initialState);
  const [customerName, setCustomerName] = useState('');
  const roleOptions = rolesByName.map((x) => ({
    key: x.id,
    text: x.roleName,
    value: x.id,
  }));

  useEffect(() => {
    if (rolesRegistry.size <= 1) loadRoles();
  }, [rolesRegistry.size, loadRoles]);

  useEffect(() => {
    if (user?.customerName) {
      setCustomerName(user?.customerName);
    }
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    getDepartmentsByCustomer(customerName);

    //eslint-disable-next-line
  }, [customerName]);

  useEffect(() => {
    loadAllUserss();
  }, [loadAllUserss]);

  const handleFormSubmit = async (values: GetSingleUserById) => {
    if (values.id === '') {
      rolesByName.map((x) =>
        x.id === values.roleId ? (values.roleName = x.roleName) : null,
      );
      const newDepartmentData = {
        ...values,
        id: uuid(),
      };

      let dublicateUsername: boolean = false;
      loadAllUsers.map((a) =>
        a.username === values.username ? (dublicateUsername = true) : 'false',
      );

      // let dublicateEmail: boolean = false;
      // loadAllUsers.map((a) =>
      //   a.email === values.email ? (dublicateEmail = true) : 'false',
      // );

      let dublicateDisplayname: boolean = false;
      loadAllUsers.map((a) =>
        a.displayName === values.displayName
          ? (dublicateDisplayname = true)
          : 'false',
      );
      if (!dublicateUsername && !dublicateDisplayname) {
        register(newDepartmentData, () => history('/dashboard'));
        setdepartmentdata(initialState);
      }
      if (dublicateUsername) {
        toast.error('Already this username is taken');
      }
      if (dublicateDisplayname) {
        toast.error('Already this displayname is taken');
      }
      // if (dublicateEmail) {
      //   toast.error('Already this email is taken');
      // }
    }
  };

  const handleCustomerNameChange = (e: any) => {
    setCustomerName(e.target.value);
  };

  return (
    <>
      {dashboardStore.dashboard.loadingdata === 'loading' && (
        <LoadingComponent />
      )}
      {dashboardStore.dashboard.loadingdata !== 'loading' &&
        !dashboardStore.dashboard.selectedUserRoleId.includes('UCUB01') && (
          <UnauthorizedMessage />
        )}
      {dashboardStore.dashboard.selectedUserRoleId.includes('UCUB01') && (
        <div style={!(window.innerWidth > 768) ? header : {}}>
          <Formik
            initialValues={departmentdata}
            // enableReinitialize={true}
            onSubmit={(values) => handleFormSubmit(values)}
            validationSchema={Yup.object({
              displayName: Yup.string()
                .min(2, 'Too Short!')
                .max(15, 'Too Long it should be upto 15 characters!')
                .required('Please enter a displayname')
                .test(
                  'unique',
                  'Display name already exists.',
                  (value: any) => !loadAllUsers.includes(value),
                ),
              // .required("Please enter a displayname").max(70),
              username: Yup.string()
                .min(2)
                .max(70)
                .required('Please enter a username')
                .matches(/^\S*$/, 'Whitespace is not allowed'),
              email: Yup.string().email().required('Please enter a email'),
              password: Yup.string()
                .required('Please Enter your New password')
                /* eslint-disable */
                .matches(
                  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
                  'Must Contain 8 to 18 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character',
                ),
              // customerName: Yup.string().min(2).max(70),
              departmentName: Yup.string().required(
                'Please select a department',
              ),
              addressLine1: Yup.string()
                .min(2)
                .max(150)
                .required('Please enter address'),
              addressLine2: commonStore.staticDemoChanges
                ? Yup.string().min(2).max(150).required('Please enter Branch')
                : Yup.string().min(2).max(150),
              phoneNumber: Yup.string()
                .min(9)
                .max(16)
                .matches(phoneRegExp, 'Please enter a valid phone number')
                .required('Please enter your phone number'),
              alternatePhoneNumber: Yup.string()
                .min(9)
                .max(16)
                .matches(phoneRegExp, 'Please enter a valid phone number'),
              roleId: Yup.string().required('Please choose your role'),
            })}
          >
            {({ isValid, dirty, handleSubmit }) => (
              <>
                <h1
                  style={{ color: 'black' }}
                  //Create User
                >
                  {
                    (userLanguage[0].UserCreateUser?.UCUML01 as any)?.[
                      `${commonStore.language.key}`
                    ]
                  }
                </h1>
                <Form
                  // style={{overflow:'auto'}}
                  className="ui form error"
                  onSubmit={handleSubmit}
                  // autoComplete="off"
                >
                  <Grid container columns={2}>
                    <Grid.Column mobile={16} computer={8} tablet={8}>
                      <MyTextInput
                        //  as={TextField}
                        name="displayName"
                        label={
                          (userLanguage[0].UserCreateUser?.UCUL01 as any)?.[
                            `${commonStore.language.key}`
                          ]
                        } //"Display Name"
                        placeholder={
                          (userLanguage[0].UserCreateUser?.UCUTB01 as any)?.[
                            `${commonStore.language.key}`
                          ]
                        } //"Display Name"
                        mandatory
                      />
                    </Grid.Column>
                    <Grid.Column mobile={16} computer={8} tablet={8}>
                      <MyTextInput
                        name="username"
                        label={
                          commonStore.staticDemoChanges
                            ? 'Registration Number or '.concat(
                                (
                                  userLanguage[0].UserCreateUser?.UCUL02 as any
                                )?.[`${commonStore.language.key}`],
                              )
                            : (userLanguage[0].UserCreateUser?.UCUL02 as any)?.[
                                `${commonStore.language.key}`
                              ]
                        } //"UserName"
                        placeholder={
                          commonStore.staticDemoChanges
                            ? 'Registration Number or '.concat(
                                (
                                  userLanguage[0].UserCreateUser?.UCUTB02 as any
                                )?.[`${commonStore.language.key}`],
                              )
                            : (
                                userLanguage[0].UserCreateUser?.UCUTB02 as any
                              )?.[`${commonStore.language.key}`]
                        } //"UserName"
                        mandatory
                      />
                    </Grid.Column>

                    <Grid.Column mobile={16} computer={8} tablet={8}>
                      <MyTextInput
                        name="email"
                        label={
                          (userLanguage[0].UserCreateUser?.UCUL03 as any)?.[
                            `${commonStore.language.key}`
                          ]
                        } //"Email"
                        placeholder={
                          (userLanguage[0].UserCreateUser?.UCUTB03 as any)?.[
                            `${commonStore.language.key}`
                          ]
                        } //"Email"
                        mandatory
                      />
                    </Grid.Column>
                    <Grid.Column mobile={16} computer={8} tablet={8}>
                      <MyTextInput
                        name="password"
                        label={
                          (userLanguage[0].UserCreateUser?.UCUL04 as any)?.[
                            `${commonStore.language.key}`
                          ]
                        } //"Password"
                        placeholder={
                          (userLanguage[0].UserCreateUser?.UCUTB04 as any)?.[
                            `${commonStore.language.key}`
                          ]
                        } //"Password"
                        type="password"
                        mandatory
                      />
                    </Grid.Column>
                    <Grid.Column mobile={16} computer={8} tablet={8}>
                      <MySelectInput
                        name="departmentName"
                        label={
                          (userLanguage[0].UserCreateUser?.UCUL05 as any)?.[
                            `${commonStore.language.key}`
                          ]
                        }
                        placeholder={
                          (userLanguage[0].UserCreateUser?.UCUTB05 as any)?.[
                            `${commonStore.language.key}`
                          ]
                        }
                        options={createUserDepartmentList}
                        clearable={false}
                        mandatory
                      />
                    </Grid.Column>
                    {commonStore.staticDemoChanges && (
                      <Grid.Column mobile={16} computer={8} tablet={8}>
                        <MyTextInput
                          name="addressLine2"
                          label={'Branch'} //"Address Line 2"
                          placeholder={'Branch'} //"Address Line 2"
                          mandatory
                        />
                      </Grid.Column>
                    )}
                    <Grid.Column mobile={16} computer={8} tablet={8}>
                      <MyTextInput
                        name="customerName"
                        label={
                          (userLanguage[0].UserCreateUser?.UCUL06 as any)?.[
                            `${commonStore.language.key}`
                          ]
                        } //"Customer Name"
                        placeholder={
                          (userLanguage[0].UserCreateUser?.UCUTB06 as any)?.[
                            `${commonStore.language.key}`
                          ]
                        } //"Customer Name"
                        disabled={user?.isAdmin === true ? false : true}
                        value={customerName}
                        onChange={handleCustomerNameChange}
                      />
                    </Grid.Column>
                    <Grid.Column mobile={16} computer={8} tablet={8}>
                      <MyTextInput
                        name="addressLine1"
                        label={
                          (userLanguage[0].UserCreateUser?.UCUL07 as any)?.[
                            `${commonStore.language.key}`
                          ]
                        } //"Address Line 1"
                        placeholder={
                          (userLanguage[0].UserCreateUser?.UCUTB07 as any)?.[
                            `${commonStore.language.key}`
                          ]
                        } //"Address Line 1"
                        mandatory
                      />
                    </Grid.Column>
                    {!commonStore.staticDemoChanges && (
                      <Grid.Column mobile={16} computer={8} tablet={8}>
                        <MyTextInput
                          name="addressLine2"
                          label={
                            (userLanguage[0].UserCreateUser?.UCUL08 as any)?.[
                              `${commonStore.language.key}`
                            ]
                          } //"Address Line 2"
                          placeholder={
                            (userLanguage[0].UserCreateUser?.UCUTB08 as any)?.[
                              `${commonStore.language.key}`
                            ]
                          } //"Address Line 2"
                        />
                      </Grid.Column>
                    )}
                    <Grid.Column mobile={16} computer={8} tablet={8}>
                      <MyTextInput
                        name="phoneNumber"
                        label={
                          (userLanguage[0].UserCreateUser?.UCUL09 as any)?.[
                            `${commonStore.language.key}`
                          ]
                        } //"Phone Number"
                        placeholder={
                          (userLanguage[0].UserCreateUser?.UCUTB09 as any)?.[
                            `${commonStore.language.key}`
                          ]
                        } //"Phone Number"
                        mandatory
                      />
                    </Grid.Column>
                    <Grid.Column mobile={16} computer={8} tablet={8}>
                      <MyTextInput
                        name="alternatePhoneNumber"
                        label={
                          (userLanguage[0].UserCreateUser?.UCUL10 as any)?.[
                            `${commonStore.language.key}`
                          ]
                        } //"Alternate Phone Number"
                        placeholder={
                          (userLanguage[0].UserCreateUser?.UCUTB10 as any)?.[
                            `${commonStore.language.key}`
                          ]
                        } //"Alternate Phone Number"
                      />
                    </Grid.Column>
                    <Grid.Column mobile={16} computer={8} tablet={8}>
                      {!commonStore.filterModeTwo.includes('SRPB01') &&
                        (window.innerWidth > 768 ? (
                          <div className="Register-form-roleId">
                            <div className="Register-form-roleId-input">
                              <MySelectInput
                                name="roleId"
                                label={
                                  (
                                    userLanguage[0].UserCreateUser
                                      ?.UCUL11 as any
                                  )?.[`${commonStore.language.key}`]
                                } //"Roles"
                                placeholder={
                                  (
                                    userLanguage[0].UserCreateUser
                                      ?.UCUDD01 as any
                                  )?.[`${commonStore.language.key}`]
                                } //"Roles"
                                options={roleOptions}
                                clearable
                                disabled={commonStore.filterModeZero.includes(
                                  'SRPB01',
                                )}
                                mandatory
                              />
                            </div>
                            <Button
                              onClick={() => modalStore.closeModal()}
                              as={Link}
                              to="/roles"
                              style={{
                                borderRadius: '30px',
                                marginTop: '25px',
                                height: '30px',
                              }}
                              icon="settings"
                              positive
                              size="mini"
                            />
                          </div>
                        ) : (
                          <>
                            <MySelectInput
                              name="roleId"
                              label={
                                (
                                  userLanguage[0].UserCreateUser?.UCUL11 as any
                                )?.[`${commonStore.language.key}`]
                              } //"Roles"
                              placeholder={
                                (
                                  userLanguage[0].UserCreateUser?.UCUDD01 as any
                                )?.[`${commonStore.language.key}`]
                              } //"Roles"
                              options={roleOptions}
                              clearable
                              disabled={commonStore.filterModeZero.includes(
                                'SRPB01',
                              )}
                              mandatory
                            />
                          </>
                        ))}
                    </Grid.Column>

                    <Grid.Column
                      mobile={16}
                      computer={8}
                      tablet={8}
                      style={{ marginTop: '10px' }}
                    >
                      <Button.Group
                        floated="right"
                        style={{ marginBottom: '20px' }}
                      >
                        <Button
                          onClick={() => modalStore.closeModal()}
                          type="reset"
                          //Cancel
                        >
                          {' '}
                          {
                            (userLanguage[0].UserCreateUser?.UCUB01 as any)?.[
                              `${commonStore.language.key}`
                            ]
                          }{' '}
                        </Button>
                        {commonStore.filterModeTwo?.includes('UCUB02') ? (
                          <></>
                        ) : (
                          <Button.Or
                            text={
                              (userLanguage[0].UserCreateUser?.UCUB02 as any)?.[
                                `${commonStore.language.key}`
                              ]
                            }
                          />
                        )}
                        {commonStore.filterModeTwo?.includes('UCUB02') ? (
                          <></>
                        ) : (
                          <Button
                            disabled={
                              !(dirty && isValid) ||
                              commonStore.filterModeZero?.includes('UCUB02')
                            }
                            positive
                            content="Register"
                            type="submit"
                            //Register
                          >
                            {
                              (userLanguage[0].UserCreateUser?.UCUB03 as any)?.[
                                `${commonStore.language.key}`
                              ]
                            }{' '}
                          </Button>
                        )}
                      </Button.Group>
                    </Grid.Column>
                  </Grid>
                </Form>
              </>
            )}
          </Formik>
        </div>
      )}
    </>
  );
});
